if (!customElements.get('ak-paste-guide')) {
  customElements.define('ak-paste-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        window.addEventListener('pageshow', this.onPageShowBound);
        return;
      }
      this.ready = true;
      this.busy = false;
      this.locked = false;
      this.buttonDefaults = new Map();
      this.onPageShowBound = event => {
        if (!event.persisted) return;
        if (!this.busy && !this.locked) this.restoreButtons();
        this.refreshCartCount();
      };
      window.addEventListener('pageshow', this.onPageShowBound);
      this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
      this.money = new Intl.NumberFormat('hr-HR', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.querySelectorAll('[data-ak-card]').forEach(card => {
        const form = card.querySelector('form');
        if (!form) return;
        const button = form.querySelector('.ak-paste-submit');
        this.buttonDefaults.set(button, { disabled: button.disabled, label: button.textContent });
        const qty = form.querySelector('[name="quantity"]');
        const pad = form.querySelector('[data-ak-pad]');
        const extras = [...form.querySelectorAll('[data-ak-extra]')];
        const update = () => {
          const n = Number(qty.value);
          const valid = Number.isInteger(n) && n >= 1 && n <= 99;
          const sum = Number(card.dataset.price) * n + (pad?.checked && !pad.disabled ? Number(card.dataset.padPrice) : 0) + extras.reduce((total, extra) => total + (extra.checked && !extra.disabled ? Number(extra.dataset.price) : 0), 0);
          card.querySelector('[data-ak-total]').textContent = valid ? this.money.format(sum / 100) : '—';
        };
        qty.addEventListener('input', update);
        pad?.addEventListener('change', update);
        extras.forEach(extra => extra.addEventListener('change', update));
        form.addEventListener('submit', event => this.submit(event, card));
        update();
      });
      try {
        const savedCount = sessionStorage.getItem('ak-paste-guide-cart-count');
        if (savedCount !== null && /^\d+$/.test(savedCount)) this.syncCartCount({ item_count: Number(savedCount) });
      } catch {}
      this.refreshCartCount();
    }
    async cart() {
      const response = await fetch(this.root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('cart-read');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('cart-shape');
      return cart;
    }
    amounts(cart) {
      const map = new Map();
      cart.items.forEach(item => map.set(String(item.variant_id), (map.get(String(item.variant_id)) || 0) + item.quantity));
      return map;
    }
    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onPageShowBound);
    }
    refreshCartCount() {
      const revision = this.cartCountRevision || 0;
      this.cart().then(cart => {
        if ((this.cartCountRevision || 0) === revision) this.syncCartCount(cart);
      }).catch(() => {});
    }
    syncCartCount(cart) {
      if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
      this.cartCountRevision = (this.cartCountRevision || 0) + 1;
      try { sessionStorage.setItem('ak-paste-guide-cart-count', String(cart.item_count)); } catch {}
      document.querySelectorAll('[data-cart-count-indicator], .cart-item-count-header--quantity').forEach(badge => {
        badge.textContent = String(cart.item_count);
        badge.classList.toggle('hide', cart.item_count === 0);
        badge.closest('a')?.classList.toggle('cart-count-visible', cart.item_count > 0);
      });
    }
    restoreButtons() {
      this.busy = false;
      this.buttonDefaults.forEach((original, button) => {
        button.disabled = original.disabled;
        button.textContent = original.label;
        button.removeAttribute('aria-busy');
      });
    }
    setButtons(disabled) {
      this.buttonDefaults ||= new Map();
      this.querySelectorAll('.ak-paste-submit').forEach(button => {
        if (!this.buttonDefaults.has(button)) {
          this.buttonDefaults.set(button, { disabled: button.disabled, label: button.textContent });
        }
        button.disabled = disabled || this.buttonDefaults.get(button).disabled;
        if (disabled) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      });
    }
    async submit(event, card) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.locked) return;
      const form = event.currentTarget;
      if (!form.reportValidity()) return;
      this.busy = true;
      this.setButtons(true);
      const button = form.querySelector('.ak-paste-submit');
      const label = button.textContent;
      const message = card.querySelector('[data-ak-message]');
      const link = card.querySelector('[data-ak-cart]');
      message.textContent = '';
      button.textContent = this.dataset.adding;
      let before;
      try {
        before = await this.cart();
      } catch {
        message.textContent = this.dataset.beforeError;
        link.hidden = false;
        button.textContent = label;
        this.busy = false;
        this.setButtons(false);
        return;
      }
      const items = [{ id: Number(card.dataset.variant), quantity: Number(form.querySelector('[name="quantity"]').value) }];
      const pad = form.querySelector('[data-ak-pad]');
      if (pad?.checked && !pad.disabled) items.push({ id: Number(card.dataset.padVariant), quantity: 1 });
      form.querySelectorAll('[data-ak-extra]').forEach(extra => {
        if (extra.checked && !extra.disabled) items.push({ id: Number(extra.dataset.variant), quantity: 1 });
      });
      let writeOk = false;
      try {
        const response = await fetch(this.root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), signal: AbortSignal.timeout(15000) });
        writeOk = response.ok;
      } catch {}
      let after;
      try { after = await this.cart(); } catch {}
      const original = this.amounts(before);
      const current = after ? this.amounts(after) : null;
      const emptyCartInitialized = current && before.items.length === 0 && current.size === items.length && items.every(item => current.get(String(item.id)) === item.quantity);
      const verified = current && (before.token === after.token || emptyCartInitialized) && items.every(item => (current.get(String(item.id)) || 0) - (original.get(String(item.id)) || 0) === item.quantity);
      if (writeOk && verified) {
        this.syncCartCount(after);
        this.restoreButtons();
        location.assign(this.dataset.cartUrl);
        return;
      }
      this.locked = true;
      this.busy = false;
      button.textContent = label;
      link.hidden = false;
      const changed = current && [...new Set([...original.keys(), ...current.keys()])].some(id => (current.get(id) || 0) !== (original.get(id) || 0));
      message.textContent = !after ? this.dataset.ambiguous : changed ? this.dataset.partial : this.dataset.unchanged;
      link.focus();
    }
  });
}
